import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb, Button } from 'antd'
import { isMobile } from '../utils/utils'
import '../assets/css/concatAsset.css'
import trustService from '../assets/images/trustService.svg'
import fundService from '../assets/images/fundService.svg'
import tel02 from '../assets/images/tel02.svg'
import mail01 from '../assets/images/mail01.svg'
import address01 from '../assets/images/address01.svg'

class ConcatAsset extends Component {
    render () {
        return(
            <div>
                <div className="banner-item banner-concat">
                    <div className="l-container">
                        <h2>联系资产托管部</h2>
                    </div>
                </div>
                <div className="page-title l-container">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item><a href="/gs/">首页</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/gs/business/">我们的业务</a></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/">资产托管与基金服务</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/concatAsset">联系托管部</Link></Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="page-content-concat">
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>业务咨询</h2>
                            <div className="consult-box">
                                <div>
                                    <img src={trustService} alt="trustService"/>
                                    <div>
                                        <p>托管业务 热线电话：</p>
                                        <p>0755-22940701 / 22940705</p>
                                    </div>
                                </div>
                                <div>
                                    <img src={fundService} alt="fundService"/>
                                    <div>
                                        <p>基金服务 热线电话：</p>
                                        <p>0755-22940703 / 22940704</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>业务洽谈</h2>
                            <div className="chat-box">
                                <div>
                                    <div className="chat-box-t"><Button>深圳</Button></div>
                                    <div className="chat-box-b">
                                        <p><img src={address01} alt="address01"/>深圳市南山区学府路85号软件产业基地1栋A座22楼</p>
                                        <p><img src={tel02} alt="tel02"/>
                                            { isMobile() ?
                                                <><span>0755-22940701</span><br /><span style={{marginLeft:42}}>0755-22940703</span></>
                                                :
                                                <>0755-22940701、0755-22940703</>
                                            }
                                        </p>
                                        <p><img src={mail01} alt="mail01"/>03556@guosen.com.cn</p>
                                    </div>
                                </div>
                                <div>
                                    <div className="chat-box-t"><Button>上海</Button></div>
                                    <div className="chat-box-b">
                                        <p><img src={address01} alt="address01"/>上海市浦东新区民生路1199弄1号楼11楼</p>
                                        <p><img src={tel02} alt="tel02"/>
                                        { isMobile() ?
                                                <><span>0755-22940701</span><br /><span style={{marginLeft:42}}>0755-22940703</span></>
                                                :
                                                <>0755-22940701、0755-22940703</>
                                        }
                                        </p>
                                        <p><img src={mail01} alt="mail01"/>03556@guosen.com.cn</p>
                                    </div>
                                </div>
                                <div>
                                    <div className="chat-box-t"><Button>北京</Button></div>
                                    <div className="chat-box-b">
                                        <p><img src={address01} alt="address01"/>北京市西城区兴盛街6号国信证券大厦6F</p>
                                        <p><img src={tel02} alt="tel02"/>
                                        {
                                            isMobile() ?
                                            <><span>0755-22940701</span><br /><span style ={{marginLeft:42}}>0755-22940703</span></>
                                            :
                                            <>0755-22940701、0755-22940703</>
                                        }
                                        </p>
                                        <p><img src={mail01} alt="mail01"/>03556@guosen.com.cn</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ConcatAsset
